import React, { useEffect, useState } from "react";

import { api, IListTerminals, Terminal } from "../../logic/api";
import { PagedDataView } from "../../components/lists/PagedDataView/PagedDataView";

import propTypes from "prop-types";
import TerminalListItem from "./components/TerminalListItem";
import { IconButton } from "@mui/material";
import { FiPlus } from "react-icons/fi";
import TerminalEditorDialog from "./components/TerminalEditorDialog";
import { useTranslation } from "react-i18next";

const TerminalManager: React.FunctionComponent<{
  customerId: number;
}> = (props) => {
  const [selectedTerminal, setSelectedTerminal] = useState<Terminal | null>(null);

  const [terminalListFetchParams, setTerminalListFetchParams] = useState<IListTerminals>({
    customerId: props.customerId
  });

  const [showTerminalDialog, setShowTerminalDialog] = useState(false);
  const { t } = useTranslation();



  useEffect(() => {
    setTerminalListFetchParams({ ...terminalListFetchParams, customerId: props.customerId });
  }, [props.customerId]);

  const TerminalDialog = () => {

    return (
      <TerminalEditorDialog
        customerId={props.customerId}
        terminal={selectedTerminal}
        show={showTerminalDialog}
        onClose={(didSave) => {
          setSelectedTerminal(null);
          setShowTerminalDialog(false);
          if (didSave == true) {
            setTerminalListFetchParams({ ...terminalListFetchParams });
          }
        }}
      ></TerminalEditorDialog>
    );
  };

  return (
    <div>
      <TerminalDialog />
      <div style={{ textAlign: "right", marginBottom: 20 }}>
        <IconButton
          onClick={() => {
            setShowTerminalDialog(true);
            setSelectedTerminal(null);
          }}
        >
          <FiPlus />
        </IconButton>
      </div>
      <PagedDataView<IListTerminals, Terminal>
        apiHook={api.hooks.admin.listTerminals}
        parameters={terminalListFetchParams}
        renderItem={(item) => {

          return (
            <TerminalListItem terminal={item} onEdit={(cp) => {
              setShowTerminalDialog(true);
              setSelectedTerminal(cp);
            }}></TerminalListItem>
          );
        }}
      >
        {t("admin.noTerminals")}
      </PagedDataView>
    </div>
  );
};

TerminalManager.propTypes = {
  customerId: propTypes.number.isRequired,
};

export default TerminalManager;

